const sizes = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
}

export const media = {
  sm: `(min-width: ${sizes.sm})`,
  md: `(min-width: ${sizes.md})`,
  lg: `(min-width: ${sizes.lg})`,
  xl: `(min-width: ${sizes.xl})`,
}

export default media
